import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getProductsArchivesURL } from '../utils/api';

const useGetProductsArchives = ({ 
        page = 1,
        limit = 3000,
        status, 
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingProductsArchives, setGettingProductsArchives ] = useState(false);
    const [ productsArchives, setProductsArchives ] = useState([]);
    const [ totalProductsArchives, setTotalProductsArchives ] = useState(0);
    const [ gettingProductsArchivesReqSuccess, setGettingProductsArchivesReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingProductsArchives) {
            axios.get(getProductsArchivesURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    status,
                }
            }).then(result => {
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalProductsArchives(result.data.total);
                    }
                    setProductsArchives(data);         
                    setGettingProductsArchivesReqSuccess(true);
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingProductsArchivesReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
                setGettingProductsArchives(false);
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingProductsArchivesReqSuccess(false);
                setGettingProductsArchives(false);
            });
        }
    }, [gettingProductsArchives]);

    return { productsArchives, totalProductsArchives, gettingProductsArchives, setGettingProductsArchives, gettingProductsArchivesReqSuccess };
}

export default useGetProductsArchives;